import styled from 'styled-components';
import media from '../../../styles/media';
import { AllProjectsContainer } from '../AllProjectsPage/styles';

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  font-weight: 400;
  margin: auto;

  p {
    color: ${(props) => props.theme.colors.darkTextPale} !important;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  span {
    font-weight: 500;
    color: ${(props) => props.theme.colors.darkText};
  }

  blockquote {
    border-left: 3px solid #ccc;
    margin: 0;
    padding-left: 14px;
    margin-bottom: 28px;
  }
  padding-bottom: 60px;
  margin-bottom: 30px;

  .image {
    max-width: 1920px;
    max-height: 650px;
    height: 50%;
    width: 100%;
    margin-bottom: 20px;
    margin: 0 auto;

    img {
      max-height: 500px;
      max-height: 650px;
      width: 100%;
      object-fit: cover;
    }
  }
`;

export const TechnologiesContainer = styled(AllProjectsContainer)`
  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex: 1;
      ${media('medium')} {
        max-width: 180px;
      }
      a {
        width: 100%;
        > div {
          width: 100%;
          max-width: 85px;
          margin: auto;
        }
        p {
          line-height: 1.2em;
        }
      }
    }
  }
`;

export const DevelopmentTimeContainer = styled(AllProjectsContainer)`
  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    ${media('medium')} {
      flex-direction: row;
      justify-content: space-between;
    }
    li {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      ${media('medium', true)} {
        + li {
          margin-top: 26px;
        }
      }
      h3 {
        font-size: 60px;
        margin: 0;
        font-weight: 400;
      }
    }
  }
  > div {
    margin-top: 36px;
    display: flex;
    justify-content: center;
    a {
      margin: 8px;
    }
  }
`;

export const ProjectDetailsContainer = styled(AllProjectsContainer)`
  h2 {
    margin-top: 48px;
  }
  /* p > span {
    max-height: 350px;
    max-width: 75% !important;
    margin: 10px;
    overflow: hidden;
    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  } */
  p > img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    object-fit: contain;
    width: 100%;
    height: 100%;
    max-width: 100% !important;

    ${media('medium')} {
      max-height: 700px;
      max-width: 75% !important;
    }
  }
  p > a {
    text-decoration: underline !important;
    font-weight: 400 !important;
  }
`;

export const ProjectFinalCta = styled.div`
  width: 100%;

  section {
    padding: 64px 26px;
  }

  p {
    color: ${(props) => props.theme.colors.darkText} !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) => props.theme.colors.darkText};
  }
`;
